import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import * as func from "../../../../../utils/functions";

import * as Actions from "../../../../../store/modules/resources";
import * as FActions from "../../../../../store/modules/footer";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRedo} from "@fortawesome/free-solid-svg-icons";

import EditInput from "../../../../etc/admin/input"

class ExtendForm extends Component {
	constructor(props) {
		super(props);
	}

	showMessage(message) {
		this.props.fDataActions.setFooter({
			'isNoticePopup': true,
			'noticeMessage': message
		})
		setTimeout(() => {
			this.props.fDataActions.setFooter({
				'isNoticePopup': false,
				'noticeMessage': ''
			})
		}, 3000);
	}

	onChange = (e) => {
		let record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.dataActions.setResource({"record": record});
		this.forceUpdate()
	};

	onUpdate = () => {
		if (func.getParams("record_id")) {
			func.updateData("admin/resource/" + func.getParams("record_id") + "/update", this.props.record).then((response) => {
				if (response.code === 'ok') {
					this.showMessage('저장 되었습니다.');
					func.getData("admin/resource/" + func.getParams("record_id"), null).then((response) => {
						this.props.dataActions.setResource(response);
						this.memo.value = ''
					});
				} else {
					this.showMessage('저장 실패 : ' + response.message)
				}
			})
		}
	}

	// onInsertNote = () => {
	// 	if(this.memo.value) {
	// 		if(func.getParams("record_id")) {
	// 			func.updateData("admin/resource/" + func.getParams("record_id") + "/memo/insert", this.props.record).then((response) => {
	// 				if (response.code === 'ok') {
	// 					this.showMessage('저장 되었습니다.');
	// 				} else {
	// 					this.showMessage('저장 실패 : ' + response.message)
	// 				}
	// 			})
	// 		}
	// 	} else {
	// 		alert('참고사항을 작성해주세요.')
	// 		this.memo.focus()
	// 	}
	// }

	textEvent = (event) => {
		let record = this.props.record;
		record[event.target.name] = event.target.value;
		this.props.dataActions.setResource({"record": record});
	}

	render() {
		const {textEvent} = this
		const {record} = this.props

		if (!record)
			return ''

		return (
			<>
				<div className="d-flex mt-4 mb-1">
					<h5 className="mr-auto">기본 정보</h5>
					<button className="btn btn-sm btn-primary order-0" type="button" id="save_resource"
					        onClick={this.onUpdate}>저장
					</button>
					<button className="btn btn-sm btn-secondary order-1 ml-2" type="button" id="show_list">리스트</button>
				</div>
				<form className="mt-4">
					<div className="row mb-2">
						<div className="col-md-12 form-group">
							<label><strong>피인용 횟수</strong></label>
							<div className="row">
								<div className="col-md-2">
									<div className="input-group mb-3">
										<span className="input-group-text" id="basic-addon1">WOS : </span>
										<input type="text" name="wos_cited_count" className="form-control" placeholder="0"
										       value={record.cited_counts ? record.cited_counts.wos_cited_count : ''} onChange={textEvent}/>
									</div>
								</div>
								<div className="col-md-2">
									<div className="input-group mb-3">
										<input type="text" name="wos_cite_date" className="form-control" placeholder="2021-08-01"
										       value={record.cited_counts ? record.cited_counts.wos_cited_date : ''} onChange={textEvent}/>
									</div>
								</div>
								<div className="col-md-2">
									<div className="input-group mb-3">
										<span className="input-group-text" id="basic-addon1">Scopus : </span>
										<input type="text" name="scopus_cited_count" className="form-control" placeholder="0"
										       value={record.cited_counts ? record.cited_counts.scopus_cited_count : ''} onChange={textEvent}/>
									</div>
								</div>
								<div className="col-md-2">
									<div className="input-group mb-3">
										<input type="text" name="scopus_cite_date" className="form-control" placeholder="2021-08-01"
										       value={record.cited_counts ? record.cited_counts.scopus_cited_date : ''} onChange={textEvent}/>
									</div>
								</div>
								<div className="col-md-2">
									<div className="input-group mb-3">
										<span className="input-group-text" id="basic-addon1">KCI : </span>
										<input type="text" name="kci_cited_count" className="form-control" placeholder="0"
										       value={record.cited_counts ? record.cited_counts.kci_cited_count : ''} onChange={textEvent}/>
									</div>
								</div>
								<div className="col-md-2">
									<div className="input-group mb-3">
										<input type="text" name="kci_cite_date" className="form-control" placeholder="2021-08-01"
										       value={record.cited_counts ? record.cited_counts.kci_cited_date : ''} onChange={textEvent}/>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-3 form-group">
							<label htmlFor=""><strong>Open Access</strong></label>
							<div className="mt-1">
								<div className="form-check form-check-inline">
									<input className="form-check-input" type="radio" name="open_access_yn" id="oa_yes" value="Y"
									       checked={record.open_access_yn === 'Y'} onChange={this.onChange}/>
									<label className="form-check-label" htmlFor="oa_yes">예</label>
								</div>
								<div className="form-check form-check-inline">
									<input className="form-check-input" type="radio" name="open_access_yn" id="oa_no" value="N"
									       checked={record.open_access_yn !== 'N'} onChange={this.onChange}/>
									<label className="form-check-label" htmlFor="oa_no">아니오</label>
								</div>
							</div>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-12">
							<EditInput
								title="URL"
								value={record.open_access_url}
								name="open_access_url"
								onKeyUp={textEvent}
							/>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-12">
							<EditInput
								title="사사정보(Funding)"
								value=""
								name=""
								onKeyUp={textEvent}
							/>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-12">
							<label htmlFor=""><strong>초록</strong></label>
							<div className="form-floating">
								<textarea className="form-control" placeholder="" id="" name="abstract" value={record.abstract}
								          onChange={this.onChange}/>
							</div>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-12">
							<label htmlFor=""><strong>관리자 참고사항</strong></label>
							<table className="xwp-list-table xwidefat xfixed xstriped table-thin table border-bottom">
								<thead>
								<tr>
									<th scope="col" style={{width: "65%"}}>내용</th>
									<th scope="col" style={{width: "15%"}}>날짜</th>
									<th scope="col" style={{width: "20%"}}>작성자</th>
								</tr>
								</thead>
								<tbody>
								{record.note && record.note.length > 0 ? record.note.map((note, index) => {
									return (
										<tr key={index} className="list-row">
											<td><label className="m-0">{note.memo}</label></td>
											<td><label className="m-0">{note.work_datetime.split(' ')[0]}</label></td>
											<td><label className="m-0">{note.worker_name}</label></td>
										</tr>
									)
								}) :
								<tr>
									<td colSpan={3}>참고사항이 없습니다.</td>
								</tr>} 
								</tbody>
							</table>
							<div className="form-floating">
                <textarea className="form-control"
                          ref={(ref) => this.memo = ref}
                          name="memo"
                          placeholder={"입력해주세요."}
                          value={record.memo}
                          onKeyUp={textEvent}
                />
								{/*<button className="btn btn-outline-secondary btn-sm"*/}
								{/*        onClick={this.onInsertNote}*/}
								{/*        type="button" style={{float : "right", marginTop : "3px"}}>추가</button>*/}
							</div>
						</div>
					</div>
					<div className="row mb-2">
						<div className="col-md-6">
							<EditInput
								title="최초 입력일 (반입일)"
								value={record.input_date}
								name="input_date"
								onKeyUp={textEvent}
							/>
						</div>
						<div className="col-md-6">
							<EditInput
								title="최종 갱신일 (수정일)"
								value={record.modified_date}
								name="modified_date"
								onKeyUp={textEvent}
							/>
						</div>
					</div>
				</form>
			</>
		)
	}
}

export default connect(
	(state) => ({
		record: state.resources.record ? state.resources.record : {},
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch),
		fDataActions: bindActionCreators(FActions, dispatch)
	}),
)(ExtendForm)
